import { palette } from './palette';

const space = {
  0: '0',
  1: '0.25rem',
  2: '0.5rem',
  3: '0.75rem',
  4: '1rem',
  5: '1.25rem',
  6: '1.5rem',
  8: '2rem',
  10: '2.5rem',
  12: '3rem',
  16: '4rem',
  20: '5rem',
  24: '6rem',
} as const;

const durationFast = '150ms';
const durationBase = '200ms';
const durationSlow = '300ms';
const easeStandard = 'ease';
const easeOut = 'ease-out';
const transitionSlow = `${durationSlow} ${easeStandard}`;

export const foundation = {
  font: {
    family: {
      base: "-apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif",
      mono: "source-code-pro, Menlo, Monaco, Consolas, 'Courier New', monospace",
    },
    size: {
      xs: '0.75rem',
      sm: '0.875rem',
      base: '1rem',
      lg: '1.125rem',
      xl: '1.25rem',
      xl2: '1.5rem',
      xl3: '1.75rem',
      xl4: '2rem',
      xl5: '2.5rem',
      xl6: '3.5rem',
      lead: '1.375rem',
      display: 'clamp(2.4rem, 6vw, 4.4rem)',
      h1: 'clamp(2.25rem, 5vw, 3.5rem)',
      h2: 'clamp(2rem, 4vw, 2.5rem)',
      h3: 'clamp(1.5rem, 2.5vw, 1.75rem)',
    },
    weight: {
      normal: '400',
      medium: '500',
      semibold: '600',
      bold: '700',
      extrabold: '800',
    },
    lineHeight: {
      none: '1',
      tight: '1.12',
      snug: '1.3',
      normal: '1.5',
      relaxed: '1.6',
      loose: '1.7',
    },
    letterSpacing: {
      tight: '-0.03em',
      normal: '-0.02em',
      wide: '0.05em',
    },
  },
  space,
  radius: {
    sm: '0.5rem',
    md: '0.75rem',
    lg: '1rem',
    xl: '1.25rem',
    xl2: '2rem',
    full: '9999px',
  },
  shadow: {
    xs: `0 2px 4px ${palette.alpha.black[5]}`,
    sm: `0 2px 8px ${palette.alpha.black[8]}`,
    md: `0 4px 16px ${palette.alpha.black[8]}`,
    lg: `0 8px 24px ${palette.alpha.black[12]}`,
    xl: `0 12px 40px ${palette.alpha.black[12]}`,
    blue: `0 8px 24px ${palette.alpha.blue[12]}`,
    blueLg: `0 12px 40px ${palette.alpha.blue[15]}`,
    button: `0 10px 20px ${palette.alpha.blue[25]}`,
    focus: `0 0 0 3px ${palette.alpha.blue[10]}`,
    text: `0 8px 32px ${palette.alpha.black[35]}`,
  },
  blur: {
    sm: '10px',
    md: '12px',
    lg: '70px',
  },
  layout: {
    containerMaxWidth: '1200px',
    containerPadding: space[8],
    containerWide: '1400px',
    measureNarrow: '37.5rem',
    measure: '43.75rem',
    measureWide: '57.5rem',
    sectionPaddingY: space[24],
    sectionGap: space[12],
    navHeight: '4.5rem',
  },
  motion: {
    durationFast,
    durationBase,
    durationSlow,
    durationDeliberate: '900ms',
    easeStandard,
    easeOut,
    transitionFast: `${durationFast} ${easeStandard}`,
    transitionBase: `${durationBase} ${easeStandard}`,
    transitionSlow,
    transitionLift: `transform ${transitionSlow}, box-shadow ${transitionSlow}, border-color ${transitionSlow}, background-color ${transitionSlow}`,
  },
  z: {
    base: '1',
    dropdown: '10',
    sticky: '100',
    fixed: '200',
    modal: '300',
    popover: '400',
    tooltip: '500',
  },
};
